var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.372,0H25.628A3.372,3.372,0,0,1,29,3.372v16.86A3.372,3.372,0,0,1,25.628,23.6H3.372A3.372,3.372,0,0,1,0,20.233V3.372A3.372,3.372,0,0,1,3.372,0Z",
    transform: "translate(240 619.698)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233 -614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H38a5,5,0,0,1,5,5V30a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(233 614)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.697 619.698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.53,11.157H2.075A2.077,2.077,0,0,0,0,13.232v8.3A2.077,2.077,0,0,0,2.075,23.6H21.53A2.077,2.077,0,0,0,23.6,21.53v-8.3A2.077,2.077,0,0,0,21.53,11.157ZM6.27,20.838H3.5a.691.691,0,0,1-.692-.692V14.615a.692.692,0,1,1,1.383,0v4.841H6.27a.692.692,0,0,1,0,1.383Zm3.458-.692a.692.692,0,0,1-1.383,0V14.615a.692.692,0,1,1,1.383,0Zm5.511-5.365-1.383,5.532a.691.691,0,0,1-1.341,0l-1.383-5.532a.691.691,0,1,1,1.341-.335l.712,2.849.712-2.849a.691.691,0,0,1,1.341.335ZM20.1,16.689a.692.692,0,0,1,0,1.383H18.026v1.383H20.1a.692.692,0,0,1,0,1.383H17.335a.691.691,0,0,1-.692-.692V14.615a.691.691,0,0,1,.692-.692H20.1a.692.692,0,0,1,0,1.383H18.026v1.383Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.716,9.405a7.64,7.64,0,0,1,0-9.129.692.692,0,0,1,1.106.831,6.248,6.248,0,0,0,0,7.468.692.692,0,1,1-1.106.831Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.92,9.543a.692.692,0,0,1-.138-.968,6.248,6.248,0,0,0,0-7.468A.692.692,0,1,1,17.888.276a7.64,7.64,0,0,1,0,9.129A.692.692,0,0,1,16.92,9.543Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.194,8.068a4.832,4.832,0,0,1,0-6.455.692.692,0,1,1,1.031.923,3.452,3.452,0,0,0,0,4.61.692.692,0,0,1-1.031.923Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.434,8.122a.692.692,0,0,1-.054-.977,3.452,3.452,0,0,0,0-4.61.692.692,0,1,1,1.031-.923,4.832,4.832,0,0,1,0,6.455.692.692,0,0,1-.977.054Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,6.915a2.075,2.075,0,1,1,2.075-2.075A2.077,2.077,0,0,1,11.8,6.915Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.5bd6962e84d66dd388dc3b38d07341fc.svg";
export { ForwardRef as ReactComponent };